module.exports = __webpack_public_path__ + "media/images/02-94ac3a23a6f11a6580d488e9f9402684.jpg";